export const isSonnerToasterEvent = (event: Event) => {
  const target = event.target;
  return target instanceof Element && Boolean(target.closest('[data-sonner-toaster]'));
};
